/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running one round of box breathing (4-4-4-4 seconds) to reset before a stressful task.`)
};

const es_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer una ronda de respiración cuadrada (4-4-4-4 segundos) para reiniciarte antes de una tarea estresante.`)
};

const de_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Runde Box-Breathing (4-4-4-4 Sekunden) machen, um vor einer stressigen Aufgabe zurückzusetzen.`)
};

const nl_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén ronde box-breathing doen (4-4-4-4 seconden) om te resetten voor een stressvolle taak.`)
};

const fr_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectuer un cycle de respiration carrée (4-4-4-4 secondes) pour se recentrer avant une tâche stressante.`)
};

const it_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eseguire un ciclo di box breathing (4-4-4-4 secondi) per resettarsi prima di un compito stressante.`)
};

const pt_br2_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma rodada de respiração quadrada (4-4-4-4 segundos) para se recentrar antes de uma tarefa estressante.`)
};

const pt_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma ronda de respiração em caixa (4-4-4-4 segundos) para reiniciar antes de uma tarefa stressante.`)
};

const ja_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストレスのかかるタスクの前にリセットするため、ボックス呼吸（4-4-4-4秒）を1ラウンド行う。`)
};

const zh_timer_u1m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在压力较大的任务前进行一轮箱式呼吸（4-4-4-4秒），帮助调整状态。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_use2", locale)
	if (locale === "en") return en_timer_u1m_use2(inputs)
	if (locale === "es") return es_timer_u1m_use2(inputs)
	if (locale === "de") return de_timer_u1m_use2(inputs)
	if (locale === "nl") return nl_timer_u1m_use2(inputs)
	if (locale === "fr") return fr_timer_u1m_use2(inputs)
	if (locale === "it") return it_timer_u1m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_use2(inputs)
	if (locale === "pt") return pt_timer_u1m_use2(inputs)
	if (locale === "ja") return ja_timer_u1m_use2(inputs)
	return zh_timer_u1m_use2(inputs)
};